import React, { ReactElement, useState, useEffect  } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { Col, Button, Tooltip } from 'antd';
import {TAG_LIST_NAME} from '../../constants/crmConstants';
import './tag.less';
import { ReactComponent as RefreshIcon } from '../../../assets/images/svg/Refresh.svg';
import { setSelectedTagClass } from '../../../store/actions/inPatientAction';

const TagList = (props: any): ReactElement => {
  const dispatch = useDispatch();
  const {selectedTag, tagCount, resetTag, reloadTagCount, isRefreshLoading, draftCount} = props;
  const [inPatientTagDataCount, setInPatientTagDataCount] = useState([] as any);
  const {
    nextStatusFilters,
    selectedTagClass,
  } = useSelector((state: RootState): any => state.selectedInPatientDetail);

  useEffect((): any => {
    if (tagCount !== undefined && tagCount !== null) {
      setInPatientTagDataCount(tagCount);
    }
    if ( nextStatusFilters ) {
      dispatch(setSelectedTagClass(nextStatusFilters));
    }
  }, [inPatientTagDataCount, resetTag, nextStatusFilters]);

  const handleClick = (data: any): any => {
    dispatch(setSelectedTagClass(data));
    if (selectedTag !== undefined) {
      selectedTag(data);
    }
  };

  return(
    <>
      {
        TAG_LIST_NAME.map((list: any, index: number): any =>
          <Col
            key={index}
            id={list.id}
            className={`${resetTag !== true && selectedTagClass === list.id ? 'active' : ''} ${list.id} `}
            onClick={(event: any): any => {
              handleClick(event.currentTarget.id);
            }
          }>
            {list.name}
            <span>
              {
                ( list.id === 'DRAFT' && Number(draftCount) >= 0)
                  ? draftCount
                  : (tagCount.length !== 0 ? tagCount[list.id] : null)
              }
             </span>
          </Col>,
        )
     }
     <Col style={{width: '1%'}}>
        <Tooltip title="Load count" placement="left">
          <Button type="text" icon={<RefreshIcon />} loading={isRefreshLoading} onClick={reloadTagCount} />
        </Tooltip>
     </Col>
    </>
  );
};

export default TagList;
